import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-privacypage',
  templateUrl: './privacypage.component.html'
})
export class PrivacypageComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
